var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Modal } from 'src/ui/components/modal/Modal';
import { Button, EButtonType } from 'src/ui/components/button/Button';
import styles from './Inactivity.module.scss';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var Inactivity = function (props) {
    var i18n = props.i18n, onExit = props.onExit;
    var _a = useState(false), isModalOpened = _a[0], setIsModalOpened = _a[1];
    useEffect(function () {
        if (!isModalOpened) {
            var timeoutShowingModal_1 = setTimeout(function () {
                setIsModalOpened(true);
            }, 1000 * 60 * 20);
            return function () { return clearTimeout(timeoutShowingModal_1); };
        }
        else {
            var timeoutForExit_1 = setTimeout(function () {
                onExit();
            }, 1000 * 60 * 10);
            return function () { return clearTimeout(timeoutForExit_1); };
        }
    }, [isModalOpened, onExit]);
    if (!isModalOpened) {
        return null;
    }
    var handleOnCancel = function () { return setIsModalOpened(false); };
    var titleInactivityModal = getPropsByKeyPath(i18n.modules, 'userActivity.title');
    var buttonExitInactivityModal = getPropsByKeyPath(i18n.modules, 'userActivity.buttonExitLabel');
    var buttonValidInactivityModal = getPropsByKeyPath(i18n.modules, 'userActivity.buttonLabel');
    return (_jsx(Modal, __assign({ onClose: handleOnCancel, title: titleInactivityModal }, { children: _jsxs("div", __assign({ className: styles.actionsWrapper }, { children: [_jsx(Button, { type: EButtonType.NEUTRAL, isEdge: true, label: buttonExitInactivityModal, onClick: onExit }), _jsx(Button, { type: EButtonType.NEUTRAL, label: buttonValidInactivityModal, onClick: handleOnCancel })] })) })));
};
